import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/sellsy': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M539.7 237.3C542.8 225.1 544 212.5 544 199.9 544 107.4 468.6 32 376.1 32 298.9 32 231.4 85 213.1 159.8 197.7 146.6 178.1 139.3 157.9 139.3 111.6 139.3 73.9 176.9 73.9 223.2 73.9 230.6 74.9 238.2 77 245.6 34.1 265.8 6.2 309.3 6.2 356.8 6.2 424.8 61.7 480 129.4 480H510.6C578.3 480 633.8 424.8 633.8 356.8 633.8 300.4 594.9 250.8 539.7 237.3zM199.9 401.6C199.9 409.8 192.8 416.9 184.6 416.9H153.6C145.3 416.9 138.3 409.8 138.3 401.6V290.6C138.3 282.4 145.3 275.3 153.6 275.3H184.6C192.8 275.3 199.9 282.4 199.9 290.6V401.6zM289.4 401.6C289.4 409.8 282.3 416.9 274 416.9H243.1C234.8 416.9 227.8 409.8 227.8 401.6V270.1C227.8 261.8 234.8 254.8 243.1 254.8H274C282.3 254.8 289.4 261.8 289.4 270.1V401.6zM378.8 401.6C378.8 409.8 371.8 416.9 363.5 416.9H332.6C324.3 416.9 317.2 409.8 317.2 401.6V238.8C317.2 230.6 324.3 223.5 332.6 223.5H363.5C371.8 223.5 378.8 230.6 378.8 238.8V401.6zM465.9 401.6C465.9 409.8 458.8 416.9 450.5 416.9H422C413.8 416.9 406.7 409.8 406.7 401.6V176.9C406.7 168.4 413.8 161.3 422 161.3H450.5C458.8 161.3 465.9 168.4 465.9 176.9V401.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/sellsy.js
// module id = otr0
// module chunks = 144